import axios from 'axios';

import { SERVICEBASEURL } from 'enums/serviceBaseUrls';
import { Optional } from 'functions/promiseExtensions';

export function callApi(id: string): Promise<Optional<void>> {
	const url: string = `${SERVICEBASEURL.BACKEND}/BaseIngredient/Restore/${id}`;
	return axios.post(url).toOptionalVoid();
}
